import React, {useMemo, useState, useCallback, useRef, useEffect} from "react"
import {Box} from "@mui/system"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import themeV2 from "../../../theme/theme"
import themeV1 from "src/utils/theme"
import CaracteristicasSection from "./components/CaracteristicasSection"
import OfertaSection from "./components/OfertaSection"
import GarantiasSection from "./components/GarantiasSection"
import CovenantsSection from "./components/CovenantsSection"
import FormActions from "../components/FormActions"
import FormHeader from "../components/FormHeader"
import {ReactComponent as EditIcon} from "src/v2/assets/icons/lock-empty-icon.svg"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import {
    caracteristicasFields,
    contrapartesFields,
    caracteristicasRadios
} from "./components/CaracteristicasSection/constants"
import {
    ofertaFields,
    ofertaRadios,
    publicoAlvoRadios,
    publicoDatas,
    coordenadoresFields
} from "./components/OfertaSection/constants"
import AutofillFloatingMenu from "../components/AutofillMenu"
import {
    createAutofillHandlers,
    createInvalidFillHandlers,
    createClearHandlers,
    shouldEnableAutofill,
    generateCovenantAutofill,
} from "../../../utils/autofill/manual-autofill"
import {evaluateSectionValidity, getInvalidFields} from "../utils/section-validity"
import {caracteristicasSectionKeys} from "./components/CaracteristicasSection/section-keys"
import {ofertaSectionKeys} from "./components/OfertaSection/section-keys"
import {garantiasSectionKeys} from "./components/GarantiasSection/section-keys"
import {garantiasRows} from "./components/GarantiasSection/constants"
import MotorService from "../../../../services/motor-service"
import RegisterDocumentService from "src/services/register-document-service"
import {
    mapCadastroTemporarioPayload,
    mapCadastroTemporarioResponseToState,
    mapCovenantsToRows,
    mapCovenantRowToPayload,
} from "../utils/map-temporary-cadastro"
import LoaderOverlay from "../../../components/LoaderOverlay/loader-overlay"
import Loader from "../../../components/Loader/loader"
import {dispatchSnackbar} from "../../../components/SnackBar/snackbar-bus"
import {useLocation, useNavigate} from "react-router-dom"
import DuplicarModal from "../components/DuplicarModal/duplicar-modal"
import {useEmpresasAutocompleteController} from "../hooks/useEmpresasAutocompleteController"
import {useGrupoAtivosAutocompleteController} from "../hooks/useGrupoAtivosAutocompleteController"
import {useIndicadoresAutocompleteController} from "../hooks/useIndicadoresAutocompleteController"
import {useSetoresAutocompleteController} from "../hooks/useSetoresAutocompleteController"
import {useSubsetoresAutocompleteController} from "../hooks/useSubsetoresAutocompleteController"
import {useDefaultCustomSelect} from "../hooks/useDefaultCustomSelect"
import {useGarantiasValorDefault} from "../hooks/useGarantiasValorDesfault"

import {useSetorSubsetor} from "../hooks/useSetorSubsetor"
import {useEmitIdEffect} from "../hooks/useEmitIdEffect"
import {useSyncDatasCaracteristicasEffect} from "../hooks/useSyncDatasCaracteristicasEffect"
import {useValorGarantia} from "../hooks/useValorGarantia"


import DuplaConfirmacao from "../../../components/DuplaConfirmacao/DuplaConfirmacao"
import ModalDialogPage from "src/components/modal-dialog"
import RegisterEmpresa from "src/pages/empresas/register/register-empresa"

import FormSectionAccordion from "src/v2/components/FormSectionAccordion"
import Documents from "src/v2/pages/DatalakeEmission/sub-page/Documents.js"
import {TokenService} from "src/services/token-service"
import {garantiasFields} from "./components/GarantiasSection/constants"
import DatalakeService from "src/services/datalake-service"
import {ThemeProvider} from "@mui/material"
import parameterDatalakeAnbimaPrecosTpfTable
    from "../../../../pages/parameters/parameters-datalake/tables/parameter-datalake-anbima-precos-tpf-table"
import RatingSection from "./components/RatingSection"

import {
    mapCadastroOCRResponseToState,
    mapCadastroOCRPagesToState,
} from "../utils/map-cadastro-ocr"
import {DOCUMENTOS_OCR_BUCKET} from "src/settings"

const buildInitialStateFromFields = (fields) => {
    return fields.reduce((acc, field) => {
        if (field.defaultValue !== undefined) {
            acc[field.key] =
                typeof field.defaultValue === "function"
                    ? field.defaultValue()
                    : field.defaultValue
        }
        return acc
    }, {})
}

const extractErrorMessages = (data, path = []) => {
    if (!data) return []

    if (Array.isArray(data)) {
        return data.flatMap((item, index) =>
            typeof item === "string"
                ? [path.length ? `${path.join(".")}: ${item}` : item]
                : extractErrorMessages(item, [...path, index])
        )
    }

    if (typeof data === "object") {
        return Object.entries(data).flatMap(([key, value]) => extractErrorMessages(value, [...path, key]))
    }

    if (typeof data === "string") {
        return [path.length ? `${path.join(".")}: ${data}` : data]
    }

    return []
}

const normalizeCetip = (value) => (value === undefined || value === null ? "" : `${value}`.toUpperCase())

const ManualCadastroPage = () => {
    const datalakeService = useMemo(() => new DatalakeService(), [])

    const initialCaracteristicasState = useMemo(
        () =>
            buildInitialStateFromFields([
                ...caracteristicasFields,
                ...contrapartesFields,
                ...caracteristicasRadios,
            ]),
        []
    )

    const initialOfertaState = useMemo(
        () =>
            buildInitialStateFromFields([
                ...ofertaFields,
                ...ofertaRadios,
                ...publicoDatas,
                ...coordenadoresFields,
                ...publicoAlvoRadios,
            ]),
        []
    )

    const initialGarantiasState = useMemo(
        () => buildInitialStateFromFields(garantiasFields),
        []
    )
    const tokenService = new TokenService()

    const [caracteristicasState, setCaracteristicasState] = useState(initialCaracteristicasState)

    useEmitIdEffect(caracteristicasState, setCaracteristicasState)
    
    const [nomeArquivoOCR, setNomeArquivoOCR] = useState("")
    const [ocr, setOcr] = useState(false)
    const [ocrState, setOcrState] = useState({})
    const [ofertaState, setOfertaState] = useState(initialOfertaState)
    const [garantiasState, setGarantiasState] = useState(() => buildInitialStateFromFields(garantiasFields))
    const [ratingState, setRatingState] = useState({})
    const [covenantsRows, setCovenantsRows] = useState([])
    const [cadastroTemporarioInfo, setCadastroTemporarioInfo] = useState(null)
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isLoadingCadastro, setIsLoadingCadastro] = useState(false)
    const [isPublished, setIsPublished] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [isDeletingCovenant, setIsDeletingCovenant] = useState(false)
    const [activeSection, setActiveSection] = useState("caracteristicas")
    const [accordionSyncToken, setAccordionSyncToken] = useState(0)
    const initialFocusAppliedRef = useRef(false)
    const [initialFocusReady, setInitialFocusReady] = useState(false)
    const garantiasCheckKeys = useMemo(
        () => garantiasRows.filter((row) => !row.isDivider && !row.isLine).map((row) => row.key),
        []
    )
    const [modalDuplicarOpen, setModalDuplicarOpen] = useState(false)
    const [isNewRecord, setIsNewRecord] = useState(false)
    const enableAutofill = shouldEnableAutofill()
    const covenantAutofillRef = useRef(null)
    const motorService = useMemo(() => new MotorService(), [])
    const documentService = useMemo(() => new RegisterDocumentService(), [])
    const location = useLocation()
    const prefillAppliedRef = useRef(false)
    const navigate = useNavigate()
    const [registerEmpresaOpen, setRegisterEmpresaOpen] = useState(false)
    const [empresasReloadKey, setEmpresasReloadKey] = useState(0)
    const empresasAutoCompleteController = useEmpresasAutocompleteController(empresasReloadKey)
    const [grupoAtivosReloadKey] = useState(0)
    const grupoAtivosAutoCompleteController = useGrupoAtivosAutocompleteController(grupoAtivosReloadKey)
    const [indicadoresReloadKey] = useState(0)
    const indicadoresAutoCompleteController = useIndicadoresAutocompleteController(indicadoresReloadKey)
    const [setoresReloadKey] = useState(0)
    const setoresAutoCompleteController = useSetoresAutocompleteController(setoresReloadKey)
    const [subsetoresReloadKey] = useState(0)
    const setorSelecionado = caracteristicasState.setorDevedor
    const subsetoresAutoCompleteController = useSubsetoresAutocompleteController(setorSelecionado, subsetoresReloadKey)
    const cotaSubordinacaoOptions = ["Júnior", "Mezanino", "Sênior", "Única"]
    const cotaSubordinacaoController = useDefaultCustomSelect(
        cotaSubordinacaoOptions,
        {cotaSubordinacao: caracteristicasState.cotaSubordinacao}
    )

    // controla se o botao salvar ja foi clicado
    const [submitAttempted, setSubmitAttempted] = useState(false)
    const [covenantDeleteConfirm, setCovenantDeleteConfirm] = useState({
        open: false,
        row: null,
        resolver: null,
    })
    const [isPastingCovenant, setIsPastingCovenant] = useState(false)
    const [isLoadingDocuments, setIsLoadingDocuments] = useState(false)
    const [editarCetipOpen, setEditarCetipOpen] = useState(false)

    const setSectionField = useCallback((section, key, value) => {
        setSubmitAttempted(false)
        if (section === "caracteristicas") {
            setCaracteristicasState((prev) => {
                const next = {...prev, [key]: value}

                // marca edição manual
                if (key === "dataIntegralizacao") {
                    if (value && value.length >= 10) {
                        next.dataIntegralizacaoManual = true
                    } else {
                        next.dataIntegralizacaoManual = false
                    }
                }

                if (key === "dataVencimento") {
                    const resgateNao = prev.resgateAntecipado !== "sim"
                    if (!prev.dataCarenciaManual && resgateNao) {
                        next.dataCarencia = value
                    }
                }

                if (key === "resgateAntecipado") {
                    if (!prev.dataCarenciaManual) {
                        next.dataCarencia = value === "sim" ? null : prev.dataVencimento
                    }
                }

                if (key === "dataCarencia") {
                    // só marca como manual se o usuário digitou algo de fato
                    if (value && value.length >= 10) {
                        next.dataCarenciaManual = true
                    } else {
                        // limpou o campo -> volta a seguir o default (se resgate antecipado == "nao")
                        next.dataCarenciaManual = false
                    }
                }

                return next
            })
            return
        }

        if (section === "oferta") {
            setOfertaState((prev) => ({...prev, [key]: value}))
            return
        }

        if (section === "garantias") {
            setGarantiasState((prev) => ({...prev, [key]: value}))
        }

        if (section === "rating") {
            setRatingState((prev) => ({...prev, [key]: value}))
        }
    }, [])

    const handleOpenRegisterEmpresa = useCallback(() => {
        setRegisterEmpresaOpen(true)
    }, [])

    const handleCloseRegisterEmpresa = useCallback(() => {
        setRegisterEmpresaOpen(false)
    }, [])

    const handleAfterRegisterEmpresa = useCallback((message, status) => {
        const isError = status === "error"
        const text = message || (isError ? "Falha ao cadastrar empresa." : "Empresa cadastrada com sucesso.")

        dispatchSnackbar(text, isError ? "error" : "success")

        if (!isError) {
            setRegisterEmpresaOpen(false)
            setEmpresasReloadKey((prev) => prev + 1)
        }
    }, [])

    const sectionFields = useMemo(
        () => ({
            caracteristicas: [...caracteristicasFields, ...contrapartesFields, ...caracteristicasRadios],
            oferta: [...ofertaFields, ...ofertaRadios, ...publicoDatas, ...coordenadoresFields, ...publicoAlvoRadios],
            garantias: [],
        }),
        []
    )

    const isSectionValid = useCallback(
        (sectionName, keys, state) =>
            evaluateSectionValidity({
                sectionName,
                keys,
                state,
                fieldsMap: sectionFields,
            }),
        [sectionFields]
    )

    const handleOpenDuplicar = useCallback(() => {
        setModalDuplicarOpen(true)
    }, [])

    const handleConfirmarDuplicacao = (dadosDoModal) => {
        const {novoCetip, novaVersao} = dadosDoModal

        // marca duplicação
        setIsNewRecord(true)
        setIsPublished(false)

        setCadastroTemporarioInfo({
            cetip: novoCetip,
            versaoDocumento: novaVersao,
            id: undefined
        })

        setCaracteristicasState((prev) => ({
            ...prev,
            cetip: novoCetip,
            versaoDocumento: novaVersao
        }))
    }

    const headerActions = useMemo(() => ({
        download: () => {
            if (!nomeArquivoOCR) {
                dispatchSnackbar("Arquivo OCR não encontrado para download.", "warning")
                return
            }

            documentService
                .downloadFileFromDirectory(DOCUMENTOS_OCR_BUCKET, nomeArquivoOCR)
                .then((response) => {
                    const data = response?.body ?? response?.data ?? response

                    const downloadLink = data?.download_link

                    if (!downloadLink) {
                        dispatchSnackbar("Link de download não encontrado.", "warning")
                        return
                    }

                    const link = document.createElement("a")
                    link.href = downloadLink
                    link.target = "_blank"
                    link.rel = "noopener noreferrer"
                    link.download = nomeArquivoOCR

                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                })
                .catch(() => {
                    dispatchSnackbar("Erro ao baixar arquivo OCR", "error")
                })
        },
    }), [documentService, nomeArquivoOCR])

    const autofillHandlers = useMemo(() => createAutofillHandlers(setSectionField), [setSectionField])
    const invalidFillHandlers = useMemo(() => createInvalidFillHandlers(setSectionField), [setSectionField])
    const clearHandlers = useMemo(() => createClearHandlers(setSectionField), [setSectionField])
    const pageTitle = "Cadastro de Características"
    const headerTitle = ""
    const headerCetip = `CETIP ${caracteristicasState.cetip || ""}`.trim()
    const statusLabel = isPublished ? "Cadastro em Produção" : "Cadastro em andamento"
    const statusColor = isPublished ? "success" : "warning"
    const autoCompleteController = useMemo(() => ({
        empresas: empresasAutoCompleteController,
        grupoAtivos: grupoAtivosAutoCompleteController,
        indicadores: indicadoresAutoCompleteController,
        cotaSubordinacao: cotaSubordinacaoController,
        setores: setoresAutoCompleteController,
        subsetores: subsetoresAutoCompleteController
    }), [empresasAutoCompleteController, grupoAtivosAutoCompleteController, indicadoresAutoCompleteController, cotaSubordinacaoController, setoresAutoCompleteController, subsetoresAutoCompleteController])
    const isAdminUser = tokenService.verifyUserIsAdmin()
    const [openUploadModal, setOpenUploadModal] = useState(false)
    const documentosValid = useMemo(() => {
        // existe CETIP e pelo menos carregou 1 documento
        if (!cadastroTemporarioInfo?.cetip) return undefined
        if (isLoadingDocuments) return undefined
        return true
    }, [cadastroTemporarioInfo?.cetip, isLoadingDocuments])

    useGarantiasValorDefault(garantiasState, setGarantiasState)

    useValorGarantia(garantiasState, setGarantiasState)
    useSyncDatasCaracteristicasEffect(caracteristicasState, setCaracteristicasState)

    useSetorSubsetor(
        caracteristicasState.subSetorDevedor,
        caracteristicasState.devedor,
        datalakeService,
        setCaracteristicasState
    )

    useEffect(() => {
        const {origem, ocrID} = location.state || {}

        if (origem !== "OCR" || !ocrID) return

        let isActive = true

        const fetchCadastroOCR = async () => {
            setIsLoadingCadastro(true)

            try {
                setOcr(true)

                const response = await motorService.getCadastroOCR(ocrID)
                const data = response?.body ?? response?.data ?? response
                setNomeArquivoOCR(data?.NomeArquivo ?? "")

                const mapped = mapCadastroOCRResponseToState(data)
                const pages = mapCadastroOCRPagesToState(data)

                if (!isActive) return

                setCaracteristicasState((prev) => {
                    const next = {
                        ...prev,
                        ...mapped.caracteristicasState,
                    }

                    if (!next.dataIntegralizacaoManual && next.dataEmissao) {
                        next.dataIntegralizacao = next.dataEmissao
                    }

                    if (!next.dataCarenciaManual) {
                        next.dataCarencia =
                            next.resgateAntecipado === "sim"
                                ? null
                                : next.dataVencimento
                    }

                    return next
                })

                setOfertaState((prev) => ({
                    ...prev,
                    ...mapped.ofertaState,
                }))

                setGarantiasState((prev) => ({
                    ...prev,
                    ...mapped.garantiasState,
                }))

                setCovenantsRows(mapped.covenantsRows || [])
                setOcrState(pages)

                setCadastroTemporarioInfo({
                    cetip: mapped.cadastroTemporarioInfo?.cetip ?? "",
                    versaoDocumento: mapped.cadastroTemporarioInfo?.versaoDocumento ?? "",
                    id: "",
                })

                setIsNewRecord(true)
                setIsPublished(false)
            } catch (error) {
                console.error("Erro ao carregar resultado OCR", error)
                dispatchSnackbar("Erro ao carregar resultado do OCR", "error")
            } finally {
                if (isActive) {
                    setInitialFocusReady(true)
                    setIsLoadingCadastro(false)
                }
            }
        }

        fetchCadastroOCR()

        return () => {
            isActive = false
        }
    }, [location.state, motorService])

    useEffect(() => {
        if (prefillAppliedRef.current) return
        // adiciona original, novoCetip, novaVersao para logica de duplicação
        const {cadastroTemporario, cetip, versaoDocumento, id, dadosAntigos, novosDados, origem} = location.state || {}

        if (origem === "OCR") return
        
        if (!cadastroTemporario && !cetip && !versaoDocumento && !id && !dadosAntigos) return
        prefillAppliedRef.current = true
        const fetchCadastro = async () => {
            setIsLoadingCadastro(true)
            try {
                const extractData = (resp) => {
                    if (!resp) return null
                    if (Array.isArray(resp)) return resp[0]
                    if (resp.body) {
                        if (Array.isArray(resp.body)) return resp.body[0]
                        if (resp.body.data && Array.isArray(resp.body.data)) return resp.body.data[0]
                        return resp.body
                    }
                    if (resp.data) {
                        if (Array.isArray(resp.data)) return resp.data[0]
                        if (resp.data.data && Array.isArray(resp.data.data)) return resp.data.data[0]
                        return resp.data
                    }
                    return resp
                }

                let data = extractData(cadastroTemporario)
                // logica de duplicação
                if (origem === 'duplicacao' && dadosAntigos && novosDados) {
                    const idOriginal = dadosAntigos.id ?? dadosAntigos.ID

                    if (idOriginal !== undefined && idOriginal !== null && idOriginal !== "") {
                        const response = await motorService.getCadastro(idOriginal)
                        data = extractData(response) || data
                    } else {
                        const cetipOriginal = dadosAntigos.CETIP ?? dadosAntigos.cetip
                        const versaoOriginal = dadosAntigos.VersaoDocumento ?? dadosAntigos.versaoDocumento

                        if (cetipOriginal && (versaoOriginal !== undefined && versaoOriginal !== null && versaoOriginal !== "")) {
                            const response = await motorService.getCadastroTemporario(cetipOriginal, versaoOriginal)
                            data = extractData(response) || data
                        } else {
                            data = extractData(dadosAntigos)
                        }
                    }
                } else if (id) {
                    const response = await motorService.getCadastro(id)
                    data = extractData(response) || data
                } else if (cetip && (versaoDocumento !== undefined && versaoDocumento !== null && versaoDocumento !== "")) {
                    const response = await motorService.getCadastroTemporario(cetip, versaoDocumento)
                    data = extractData(response) || data
                }

                if (!data) {
                    // preenche cetip e versaoDocumento na tabela de características em CADASTRO MANUAL
                    setCaracteristicasState((prev) => ({
                        ...prev,
                        cetip: cetip ?? "",
                        versaoDocumento: versaoDocumento ?? ""
                    }))

                    setCadastroTemporarioInfo({
                        cetip: cetip ?? "",
                        versaoDocumento: versaoDocumento ?? "",
                        id: ""
                    })

                    setIsNewRecord(true)
                    setIsPublished(false)

                    return
                }

                const mapped = mapCadastroTemporarioResponseToState(data)

                if (parameterDatalakeAnbimaPrecosTpfTable)

                // se for duplicação, sobreescreve o cetip e versao no estado mapeado
                if (origem === 'duplicacao' && novosDados) {
                    mapped.caracteristicasState.cetip = novosDados.cetip
                    mapped.caracteristicasState.versaoDocumento = novosDados.versao

                    // limpa o ID para garantir criação de NOVO registro
                    if (mapped.cadastroTemporarioInfo) mapped.cadastroTemporarioInfo.id = null
                }

                setCaracteristicasState(mapped.caracteristicasState || {})
                setOfertaState(mapped.ofertaState || {})
                setGarantiasState(mapped.garantiasState || {})
                setCovenantsRows(mapped.covenantsRows || [])

                const isDuplicacao = (origem === 'duplicacao' && novosDados)

                const info = {
                    cetip:
                        (isDuplicacao ? novosDados.cetip : null) ??
                        mapped.cadastroTemporarioInfo?.cetip ??
                        cetip ??
                        data?.CETIP ??
                        data?.cetip ??
                        "",
                    versaoDocumento:
                        (isDuplicacao ? novosDados.versao : null) ??
                        mapped.cadastroTemporarioInfo?.versaoDocumento ??
                        versaoDocumento ??
                        data?.VersaoDocumento ??
                        data?.versaoDocumento ??
                        "",
                    id: isDuplicacao ? "" : (mapped.cadastroTemporarioInfo?.id ?? id ?? data?.ID ?? data?.Id ?? data?.id ?? ""),
                }
                setCadastroTemporarioInfo(info)

                // Marca como novo registro quando é duplicação
                if (isDuplicacao) {
                    setIsNewRecord(true)
                    setIsPublished(false)
                } else {
                    setIsPublished(Boolean(info.id))
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Erro ao carregar cadastro", error)
                dispatchSnackbar("Erro ao carregar cadastro selecionado", "error")
            } finally {
                setInitialFocusReady(true)
                if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
                    window.requestAnimationFrame(() => {
                        window.requestAnimationFrame(() => setIsLoadingCadastro(false))
                    })
                } else {
                    setTimeout(() => setIsLoadingCadastro(false), 0)
                }
            }
        }
        fetchCadastro()
    }, [location.state, motorService])

    useEffect(() => {
        const cadastroId = cadastroTemporarioInfo?.id
        const shouldLoadCovenantsFromProd = Boolean(isPublished && cadastroId)
        if (!shouldLoadCovenantsFromProd) return undefined

        let isActive = true

        const extractCovenants = (resp) => {
            const data = resp?.body ?? resp?.data ?? resp
            if (Array.isArray(data)) return data
            if (Array.isArray(data?.results)) return data.results
            if (Array.isArray(data?.data)) return data.data
            if (Array.isArray(data?.body)) return data.body
            return []
        }

        const fetchCovenants = async () => {
            try {
                const response = await motorService.getCadastroCovenants(cadastroId)
                if (!isActive) return
                const mapped = mapCovenantsToRows(extractCovenants(response))
                setCovenantsRows(mapped)
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Erro ao carregar covenants do cadastro publicado", error)
                dispatchSnackbar("Erro ao carregar covenants do cadastro publicado", "warning")
            }
        }

        fetchCovenants()

        return () => {
            isActive = false
        }
    }, [cadastroTemporarioInfo?.id, isPublished, motorService])

    useEffect(() => {
        if (!prefillAppliedRef.current) {
            // sem prefill, já pode aplicar foco inicial
            setInitialFocusReady(true)
        }
    }, [])

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.scrollTo({top: 0, behavior: "auto"})
        }
    }, [location.pathname])

    const sectionScrollMargin = 16

    const isSaved = Boolean(
        cadastroTemporarioInfo &&
        cadastroTemporarioInfo.cetip &&
        cadastroTemporarioInfo.versaoDocumento !== undefined &&
        cadastroTemporarioInfo.versaoDocumento !== null &&
        cadastroTemporarioInfo.versaoDocumento !== ""
    )

    const covenantsValid = useMemo(() => {
        if (!covenantsRows || !covenantsRows.length) {
            return isSaved ? true : undefined
        }

        const hasUserData = covenantsRows.some((row) => {
            const ignoreKeys = [
                "id",
                "apiId",
                "__initialized",
                "tipoCovenant",
                "dataValidadeInicial",
                "dataValidadeFinal",
            ]

            return Object.keys(row).some(
                (key) =>
                    !ignoreKeys.includes(key) &&
                    `${row[key] || ""}`.trim().length > 0
            )
        })

        if (hasUserData) return true

        return isSaved ? true : undefined
    }, [covenantsRows, isSaved])

    const garantiasSectionValid = useMemo(() => {
        const anyChecked = garantiasCheckKeys.some(
            (key) => Boolean(garantiasState[`${key}Check`])
        )

        if (!anyChecked) {
            return isSaved ? true : undefined
        }

        const allComplete = garantiasCheckKeys.every((key) => {
            const checked = Boolean(garantiasState[`${key}Check`])
            if (!checked) return true
            const decVal = `${garantiasState[`${key}Valor`] || ""}`.trim()
            return Boolean(decVal)
        })

        // Se marcou checkbox mas não preencheu valor -> False (Vermelho)
        // Se preencheu tudo -> True (Verde)
        return allComplete ? true : false

    }, [garantiasCheckKeys, garantiasState, isSaved])

    const caracteristicasValid = isSectionValid(
        "caracteristicas",
        caracteristicasSectionKeys,
        caracteristicasState
    )

    const ofertaValid = useMemo(() => {
        const valid = isSectionValid("oferta", ofertaSectionKeys, ofertaState)

        // Se validou tecnicamente, checa se tem "Alma" (dados do usuário)
        if (valid === true) {
            // Verifica se tem algum campo preenchido diferente do padrão/nulo
            const hasUserData = ofertaSectionKeys.some(key => {
                const val = ofertaState[key]
                // Ignora o valor padrão da distribuição
                if (key === 'distribuicao' && val === 'ICVM160') return false
                if (key === 'tipoMercado' && val === 'Primária') return false
                return val !== null && val !== undefined && String(val).trim() !== ""
            })

            if (hasUserData) return true

            if (isSaved) return true
            // Se não tem dados do usuário, retorna undefined (Amarelo)
            return undefined
        }
        return valid
    }, [ofertaSectionKeys, ofertaState, isSectionValid, isSaved])

    const garantiasValid = garantiasSectionValid
    const covenantsValidFinal = covenantsValid

    const showCaracteristicasError = submitAttempted && caracteristicasValid === false

    const showOfertaError = submitAttempted && ofertaValid === false

    const showGarantiasError = submitAttempted && garantiasValid === false

    const showCovenantsError = submitAttempted && covenantsValidFinal === false

    useEffect(() => {
        if (initialFocusAppliedRef.current) return
        if (!initialFocusReady && prefillAppliedRef.current) return
        const caracteristicasValid = isSectionValid("caracteristicas", caracteristicasSectionKeys, caracteristicasState)
        const ofertaValid = isSectionValid("oferta", ofertaSectionKeys, ofertaState)
        const garantiasValid = garantiasSectionValid

        const sections = [
            {key: "caracteristicas", valid: caracteristicasValid},
            {key: "oferta", valid: ofertaValid},
            {key: "garantias", valid: garantiasValid},
            {key: "covenants", valid: covenantsValid},
        ]
        const firstIncomplete = sections.find((s) => s.valid !== true)?.key || "caracteristicas"
        setActiveSection(firstIncomplete)
        setAccordionSyncToken((token) => token + 1)
        initialFocusAppliedRef.current = true
    }, [
        caracteristicasSectionKeys,
        caracteristicasState,
        covenantsValid,
        garantiasSectionKeys,
        garantiasState,
        isSectionValid,
        ofertaSectionKeys,
        ofertaState,
        initialFocusReady,
        setAccordionSyncToken,
        setActiveSection,
    ])

    const shouldSyncCovenants = useMemo(
        () => Boolean(isPublished && cadastroTemporarioInfo?.id),
        [cadastroTemporarioInfo?.id, isPublished]
    )

    const extractSingleCovenantFromResponse = useCallback((resp) => {
        const data = resp?.body ?? resp?.data ?? resp
        if (!data) return null
        if (Array.isArray(data)) return data[0]
        if (Array.isArray(data?.results)) return data.results[0]
        if (Array.isArray(data?.data)) return data.data[0]
        if (Array.isArray(data?.body)) return data.body[0]
        return data
    }, [])

    const hasCovenantData = useCallback((row) => {
        if (!row) return false
        const ignoreKeys = new Set(["id", "apiId"])
        return Object.keys(row).some((key) => !ignoreKeys.has(key) && `${row[key] || ""}`.trim().length > 0)
    }, [])

    const isSameCovenantRow = useCallback((rowA = {}, rowB = {}) => {
        const keys = [
            "dataValidadeInicial",
            "dataValidadeFinal",
            "tipoCovenant",
            "clausula",
            "numerador",
            "denominador",
            "limite",
            "observacao",
        ]
        return !keys.some((key) => `${rowA[key] || ""}`.trim() !== `${rowB[key] || ""}`.trim())
    }, [])

    const handlePersistCovenantRow = useCallback(
        async (newRow, oldRow) => {
            if (!shouldSyncCovenants || !newRow) return null
            const mergedRow = {...oldRow, ...newRow}
            const apiId = mergedRow.apiId
            const payload = mapCovenantRowToPayload(mergedRow)

            try {
                if (!apiId) {
                    if (!hasCovenantData(mergedRow)) return null
                    const response = await motorService.createCadastroCovenant(
                        cadastroTemporarioInfo.id,
                        payload
                    )
                    const created = extractSingleCovenantFromResponse(response)
                    const createdId = created?.ID ?? created?.id ?? created?.Id
                    return createdId ? {apiId: createdId, id: createdId} : null
                }
                if (oldRow && isSameCovenantRow(mergedRow, oldRow)) {
                    return {apiId}
                }
                await motorService.updateCadastroCovenant(cadastroTemporarioInfo.id, apiId, payload)
                return {apiId}
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Erro ao salvar covenant", error)
                dispatchSnackbar("Erro ao salvar covenant", "error")
                throw error
            }
        },
        [
            cadastroTemporarioInfo?.id,
            extractSingleCovenantFromResponse,
            hasCovenantData,
            isSameCovenantRow,
            motorService,
            shouldSyncCovenants,
        ]
    )

    const handlePastedCovenantRows = useCallback(
        async (pastedRows = []) => {
            if (!shouldSyncCovenants || !cadastroTemporarioInfo?.id) return
            const rowsToPersist = pastedRows.filter(hasCovenantData)
            if (!rowsToPersist.length) return

            const updates = []
            let hasError = false

            setIsPastingCovenant(true)
            try {
                for (const row of rowsToPersist) {
                    try {
                        const payload = mapCovenantRowToPayload(row)
                        const response = await motorService.createCadastroCovenant(cadastroTemporarioInfo.id, payload)
                        const created = extractSingleCovenantFromResponse(response)
                        const createdId = created?.ID ?? created?.id ?? created?.Id
                        if (createdId && row?.id) {
                            updates.push({localId: row.id, apiId: createdId})
                        }
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.error("Erro ao salvar covenant colado", error)
                        hasError = true
                    }
                }

                if (updates.length) {
                    setCovenantsRows((prev) =>
                        prev.map((row) => {
                            const match = updates.find((item) => item.localId === row.id)
                            return match ? {...row, apiId: match.apiId, id: match.apiId} : row
                        })
                    )
                }

                if (hasError) {
                    dispatchSnackbar("Erro ao salvar covenant colado", "error")
                }
            } finally {
                setIsPastingCovenant(false)
            }
        },
        [
            cadastroTemporarioInfo?.id,
            extractSingleCovenantFromResponse,
            hasCovenantData,
            motorService,
            mapCovenantRowToPayload,
            shouldSyncCovenants,
        ]
    )

    const handleDeleteCovenantRow = useCallback(
        async (row) => {
            if (!hasCovenantData(row)) return true
            return new Promise((resolve) => {
                setCovenantDeleteConfirm({
                    open: true,
                    row,
                    resolver: resolve,
                })
            })
        },
        [hasCovenantData]
    )

    const handleConfirmDeleteCovenant = useCallback(async () => {
        const {row, resolver} = covenantDeleteConfirm
        const finish = (result) => {
            resolver?.(result)
            setCovenantDeleteConfirm({open: false, row: null, resolver: null})
            setIsDeletingCovenant(false)
        }
        try {
            setIsDeletingCovenant(true)
            if (row?.apiId) {
                await motorService.deleteCadastroCovenant(cadastroTemporarioInfo.id, row.apiId)
            }
            finish(true)
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Erro ao deletar covenant", error)
            dispatchSnackbar("Erro ao deletar covenant", "error")
            finish(false)
        }
    }, [covenantDeleteConfirm, cadastroTemporarioInfo?.id, motorService])

    const handleCancelDeleteCovenant = useCallback(() => {
        const {resolver} = covenantDeleteConfirm
        resolver?.(false)
        setCovenantDeleteConfirm({open: false, row: null, resolver: null})
    }, [covenantDeleteConfirm])

    const handleCovenantUpdateError = useCallback((error) => {
        // eslint-disable-next-line no-console
        console.error("Falha ao atualizar covenant", error)
    }, [])

    const handleSave = useCallback(async () => {
        setSubmitAttempted(true)

        const invalidFieldsCaracteristicas = getInvalidFields({
            sectionName: "caracteristicas",
            keys: caracteristicasSectionKeys,
            state: caracteristicasState,
            fieldsMap: sectionFields
        })

        try {
            setIsSaving(true)
            const payload = mapCadastroTemporarioPayload({
                caracteristicasState,
                ofertaState,
                garantiasState,
                covenantsRows,
            })
            const hasCadastroId = Boolean(cadastroTemporarioInfo?.id)

            let response
            if (isPublished) {
                if (!hasCadastroId) {
                    throw new Error("Cadastro publicado sem ID para atualização.")
                }
                response = await motorService.updateCadastro(cadastroTemporarioInfo.id, payload)
            } else if (isNewRecord) {
                response = await motorService.createCadastroTemporario(payload)
                setIsNewRecord(false)
            } else if (hasCadastroId) {
                response = await motorService.updateCadastro(cadastroTemporarioInfo.id, payload)
            } else if (
                cadastroTemporarioInfo?.cetip != null &&
                cadastroTemporarioInfo?.versaoDocumento != null
            ) {
                response = await motorService.updateCadastroTemporario(
                    cadastroTemporarioInfo.cetip,
                    cadastroTemporarioInfo.versaoDocumento,
                    payload
                )
            } else {
                response = await motorService.createCadastroTemporario(payload)
                // Após criar o registro, não é mais um novo registro
                if (isNewRecord) {
                    setIsNewRecord(false)
                }
            }
            const savedCetip = normalizeCetip(
                response?.body?.CETIP ??
                response?.data?.CETIP ??
                payload?.CETIP ??
                cadastroTemporarioInfo?.cetip
            )
            const savedVersao =
                response?.body?.VersaoDocumento ??
                response?.data?.VersaoDocumento ??
                payload?.VersaoDocumento ??
                cadastroTemporarioInfo?.versaoDocumento
            const savedId = response?.body?.ID ?? response?.data?.ID ?? cadastroTemporarioInfo?.id
            //verifica se não é nulo/undefined, isso permite que a Versão 0 (que era tratado como falso) entre no if e atualize o estado.
            if (savedCetip && savedVersao !== undefined && savedVersao !== null) {
                setCadastroTemporarioInfo({
                    cetip: savedCetip,
                    versaoDocumento: savedVersao,
                    id: savedId
                })
            }
            const successMessage =
                response?.body?.detail ||
                response?.body?.message ||
                response?.data?.detail ||
                response?.data?.message ||
                "Cadastro temporário salvo com sucesso."
            dispatchSnackbar(successMessage, "success")
            if (invalidFieldsCaracteristicas.length === 0) {
                setSubmitAttempted(false)
            }

        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Erro ao salvar cadastro temporário", error)
            const data = error?.response?.body || error?.response?.data || error?.response?.text
            const fieldErrors = extractErrorMessages(data)
            const message =
                (fieldErrors.length ? fieldErrors.join(" | ") : undefined) ||
                (typeof data === "string" ? data : undefined) ||
                data?.detail ||
                data?.message ||
                (data && typeof data === "object" ? JSON.stringify(data) : undefined) ||
                error?.message ||
                "Falha ao salvar cadastro temporário."
            dispatchSnackbar(message, "error")
        } finally {
            setIsSaving(false)
        }
    }, [cadastroTemporarioInfo, caracteristicasState, covenantsRows, garantiasState, isNewRecord, motorService, ofertaState, caracteristicasSectionKeys, sectionFields])

    const handlePublish = useCallback(async () => {
        try {
            setIsSaving(true)
            const payload = mapCadastroTemporarioPayload({
                caracteristicasState,
                ofertaState,
                garantiasState,
                covenantsRows,
            })
            const hasCadastroId = Boolean(cadastroTemporarioInfo?.id)
            const response = hasCadastroId
                ? await motorService.updateCadastro(cadastroTemporarioInfo.id, payload)
                : await motorService.createCadastro(payload)

            // Após criar/publicar o registro, não é mais um novo registro
            if (isNewRecord) {
                setIsNewRecord(false)
            }

            const savedCetip = normalizeCetip(
                response?.body?.CETIP ??
                response?.data?.CETIP ??
                payload?.CETIP ??
                cadastroTemporarioInfo?.cetip
            )
            const savedVersao =
                response?.body?.VersaoDocumento ??
                response?.data?.VersaoDocumento ??
                payload?.VersaoDocumento ??
                cadastroTemporarioInfo?.versaoDocumento
            const savedId = response?.body?.ID ?? response?.data?.ID ?? cadastroTemporarioInfo?.id

            setCadastroTemporarioInfo({cetip: savedCetip, versaoDocumento: savedVersao, id: savedId})
            setIsPublished(true)

            const successMessage =
                response?.body?.detail ||
                response?.body?.message ||
                response?.data?.detail ||
                response?.data?.message ||
                "Cadastro publicado com sucesso."
            dispatchSnackbar(successMessage, "success")
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Erro ao publicar cadastro", error)
            const data = error?.response?.body || error?.response?.data || error?.response?.text
            const fieldErrors = extractErrorMessages(data)
            const message =
                (fieldErrors.length ? fieldErrors.join(" | ") : undefined) ||
                (typeof data === "string" ? data : undefined) ||
                data?.detail ||
                data?.message ||
                (data && typeof data === "object" ? JSON.stringify(data) : undefined) ||
                error?.message ||
                "Falha ao publicar cadastro."
            dispatchSnackbar(message, "error")
        } finally {
            setIsSaving(false)
        }
    }, [
        cadastroTemporarioInfo,
        caracteristicasState,
        covenantsRows,
        garantiasState,
        isNewRecord,
        motorService,
        ofertaState,
    ])

    const handleDelete = useCallback(async () => {
        prefillAppliedRef.current = true
        try {
            setIsDeleting(true)
            const isPublishedDelete = Boolean(cadastroTemporarioInfo?.id)
            if (isPublishedDelete) {
                await motorService.deleteCadastro(cadastroTemporarioInfo.id)
                dispatchSnackbar("Cadastro publicado deletado com sucesso.", "success")
            } else {
                if (!cadastroTemporarioInfo?.cetip || !cadastroTemporarioInfo?.versaoDocumento) {
                    dispatchSnackbar("CETIP e Versão são necessários para deletar o cadastro temporário", "warning")
                    setDeleteConfirmOpen(false)
                    return
                }
                await motorService.deleteCadastroTemporario(
                    cadastroTemporarioInfo.cetip,
                    cadastroTemporarioInfo.versaoDocumento
                )
                dispatchSnackbar("Cadastro temporário deletado com sucesso.", "success")
                setTimeout(() => {
                    navigate(-1)
                }, 1500)
            }
            setCaracteristicasState({
                ...initialCaracteristicasState,
                tipoAtivo: null,
                emissao: ""
            })
            setOfertaState(initialOfertaState)
            setGarantiasState(initialGarantiasState)
            setCovenantsRows([])
            setCadastroTemporarioInfo(null)
            setIsPublished(false)
        } catch (error) {
            console.error("Erro ao deletar cadastro temporário", error)
            const data = error?.response?.body || error?.response?.data || error?.response?.text
            const fieldErrors = extractErrorMessages(data)
            const message =
                (fieldErrors.length ? fieldErrors.join(" | ") : undefined) ||
                (typeof data === "string" ? data : undefined) ||
                data?.detail ||
                data?.message ||
                (data && typeof data === "object" ? JSON.stringify(data) : undefined) ||
                error?.message ||
                "Falha ao deletar cadastro temporário."
            dispatchSnackbar(message, "error")
        } finally {
            setIsDeleting(false)
            setDeleteConfirmOpen(false)
        }
    }, [cadastroTemporarioInfo, motorService])

    const handleEditarCetipClick = (e) => {
        e?.preventDefault()
        e?.stopPropagation()
        setEditarCetipOpen(true)
    }

    const handleConfirmEditarCetip = () => {
        setEditarCetipOpen(false)
        handlePublish()
    }

    const handleDeleteEditarCetip = () => {
        setEditarCetipOpen(false)
    }

    return (
        <SideBarLayout
            title={pageTitle}
            header
            headerTitle={headerTitle}
            headerImage={"/background/cadastro-background-header.jpg"}
        >
            {(isSaving || isLoadingCadastro || isDeleting || isDeletingCovenant || isPastingCovenant) && (
                <LoaderOverlay>
                    <Loader/>
                </LoaderOverlay>
            )}
            <Box
                sx={{
                    marginTop: -14.5,
                    paddingBottom: 5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    px: {xxxs: 3, md: 3, lg: 0},
                }}
            >
                <FormHeader
                    title={headerCetip}
                    onDownload={headerActions.download}
                    statusLabel={statusLabel}
                    statusColor={statusColor}
                    showDownload={ocr}
                />

                <div data-section="caracteristicas" style={{scrollMarginTop: sectionScrollMargin}}>
                    <CaracteristicasSection
                        ocr={ocr}
                        ocrState={ocrState}
                        state={caracteristicasState}
                        setSectionField={setSectionField}
                        isValid={caracteristicasValid}
                        showError={showCaracteristicasError}
                        defaultOpen={activeSection === "caracteristicas"}
                        syncToken={accordionSyncToken}
                        autoCompleteController={autoCompleteController}
                        onRegisterEmpresa={handleOpenRegisterEmpresa}
                    />
                </div>

                <div data-section="oferta" style={{scrollMarginTop: sectionScrollMargin}}>
                    <OfertaSection
                        ocr={ocr}
                        ocrState={ocrState}
                        state={ofertaState}
                        setSectionField={setSectionField}
                        isValid={ofertaValid}
                        showError={showOfertaError}
                        defaultOpen={activeSection === "oferta"}
                        syncToken={accordionSyncToken}
                        autoCompleteController={autoCompleteController}
                        onRegisterEmpresa={handleOpenRegisterEmpresa}
                    />
                </div>

                <div data-section="garantias" style={{scrollMarginTop: sectionScrollMargin}}>
                    <GarantiasSection
                        ocr={ocr}
                        ocrState={ocrState}
                        state={garantiasState}
                        setSectionField={setSectionField}
                        isValid={garantiasSectionValid}
                        showError={showGarantiasError}
                        defaultOpen={activeSection === "garantias"}
                        syncToken={accordionSyncToken}
                    />
                </div>

                <div data-section="garantias" style={{scrollMarginTop: sectionScrollMargin}}>
                    <RatingSection
                        caracteristicasState={caracteristicasState}
                        state={ratingState}
                        setRatingState={setRatingState}
                        setLoading={setIsLoadingCadastro}
                        setSectionField={setSectionField}
                        isValid={garantiasSectionValid}
                        showError={showGarantiasError}
                        defaultOpen={activeSection === "rating"}
                        syncToken={accordionSyncToken}
                    />
                </div>

                <div data-section="covenants" style={{scrollMarginTop: sectionScrollMargin}}>
                    <CovenantsSection
                        isValid={covenantsValid}
                        showError={showCovenantsError}
                        defaultOpen={activeSection === "covenants"}
                        onRegisterAutofill={(api) => {
                            covenantAutofillRef.current = api
                        }}
                        rows={covenantsRows}
                        onChangeRows={setCovenantsRows}
                        emissao={caracteristicasState.dataEmissao}
                        vencimento={caracteristicasState.dataVencimento}
                        syncToken={accordionSyncToken}
                        onPersistRow={shouldSyncCovenants ? handlePersistCovenantRow : undefined}
                        onDeleteRow={handleDeleteCovenantRow}
                        onRowUpdateError={shouldSyncCovenants ? handleCovenantUpdateError : undefined}
                        onRowsPasted={handlePastedCovenantRows}
                    />
                </div>
                <div data-section="DOCUMENTOS" style={{scrollMarginTop: sectionScrollMargin}}>
                    <FormSectionAccordion
                        title="Documentos"
                        defaultOpen={false}
                        isValid={documentosValid}
                        syncToken={accordionSyncToken}
                    >
                        <Documents
                            isAdmin={isAdminUser}
                            documentService={documentService}
                            cetip={cadastroTemporarioInfo?.cetip || caracteristicasState.cetip}
                            setIsLoading={setIsLoadingDocuments}
                            isOpenModalSendFile={openUploadModal}
                            onCloseModalSendFile={() => setOpenUploadModal(false)}
                        />
                    </FormSectionAccordion>
                </div>

                {enableAutofill && (
                    <AutofillFloatingMenu
                        sections={[
                            {
                                key: "caracteristicas",
                                label: "Características",
                                onValid: autofillHandlers.caracteristicas,
                                onInvalid: invalidFillHandlers.caracteristicas,
                                onClear: clearHandlers.caracteristicas,
                            },
                            {
                                key: "oferta",
                                label: "Oferta",
                                onValid: autofillHandlers.oferta,
                                onInvalid: invalidFillHandlers.oferta,
                                onClear: clearHandlers.oferta,
                            },
                            {
                                key: "garantias",
                                label: "Garantias",
                                onValid: autofillHandlers.garantias,
                                onInvalid: invalidFillHandlers.garantias,
                                onClear: clearHandlers.garantias,
                            },
                            {
                                key: "covenants",
                                label: "Covenants",
                                onValid: () => covenantAutofillRef.current?.autofill(generateCovenantAutofill),
                                onInvalid: () =>
                                    covenantAutofillRef.current?.autofill(() => ({
                                        id: Date.now(),
                                        validadeInicial: "99/99/9999",
                                        validadeFinal: "99/99/9999",
                                        tipo: ["financeiro", "operacional"][Math.floor(Math.random() * 2)],
                                        clausula: "",
                                        numerador: "abc",
                                        denominador: "xyz",
                                        limite: "",
                                        observacao: "inválido",
                                    })),
                                onClear: () => covenantAutofillRef.current?.clear(),
                            },

                            {
                                key: "documentos",
                                label: "Documentos",
                                onValid: autofillHandlers.documentos,
                                onInvalid: invalidFillHandlers.documentos,
                                onClear: clearHandlers.documentos,
                            },
                        ]}
                    />
                )}

                <FormActions
                    showBack
                    onBack={() => navigate(-1)}
                    onDelete={() => setDeleteConfirmOpen(true)}
                    onDuplicate={handleOpenDuplicar}
                    onSave={handleSave}
                    onPublish={isPublished ? handleEditarCetipClick : handlePublish}
                    onConfirmDelete={handleDelete}
                    deleteOpen={deleteConfirmOpen}
                    setDeleteOpen={setDeleteConfirmOpen}
                    theme={themeV2}
                    showSave={!isPublished}
                    publishLabel={isPublished ? "EDITAR" : "PUBLICAR"}
                    publishIcon={isPublished ? <EditIcon/> : <CheckIcon/>}
                />
            </Box>
            <DuplaConfirmacao
                open={editarCetipOpen}
                cancel={handleDeleteEditarCetip}
                confirm={handleConfirmEditarCetip}
                title="Editar"
                description="
                    Certifique-se de que todas as alterações necessárias foram feitas,
                    já que este é um registro em produção.
                "
            />
            <DuplicarModal
                open={modalDuplicarOpen}
                onClose={() => setModalDuplicarOpen(false)}
                rowOriginal={{id: cadastroTemporarioInfo?.id}}
                onConfirm={handleConfirmarDuplicacao}
            />
            <ThemeProvider theme={themeV1}>
                <ModalDialogPage
                    open={registerEmpresaOpen}
                    title="Cadastrar Características da Empresa"
                    close={handleCloseRegisterEmpresa}
                    paperSx={{backgroundColor: "#fff"}}
                    contentSx={{backgroundColor: "#fff"}}
                >
                    <RegisterEmpresa afterRegister={handleAfterRegisterEmpresa}/>
                </ModalDialogPage>
            </ThemeProvider>
            <DuplaConfirmacao
                open={covenantDeleteConfirm.open}
                cancel={handleCancelDeleteCovenant}
                confirm={handleConfirmDeleteCovenant}
                action="excluir"
                description="Confirma a exclusão deste Covenant?"
                title="Excluir Covenant"
            />
        </SideBarLayout>
    )
}

export default ManualCadastroPage

ManualCadastroPage.propTypes = {}
